import React from "react";
//

export default () => (
  <div>
    <div className="datenschutzerklaerung">
      <h1>Datenschutzerklärung</h1>

      <h2>Allgemeines</h2>
      <p>
        Der sorgfältige Umgang mit ihren personenbezogenen Daten hat höchste
        Priorität. Wir halten uns bei deren Erhebung, Verarbeitung und Nutzung
        streng an die datenschutzrechtlichen Bestimmungen des
        Datenschutzgesetzes (DSG) und der Datenschutzgrundverordnung (EU-DSGVO).
        Nachfolgend erfahren sie mehr über den Umgang mit ihren
        personenbezogenen Daten.
      </p>

      {/* <h2>Datenerfassung</h2>
      <p>
        Unsere Datenschutzbestimmungen gelten für die Nutzung des
        Kontaktformulars auf dieser Webseite. Das Kontaktformular auf unserer
        Webseite bietet interessierten Personen die Möglichkeit, mit uns in
        Kontakt zu treten bzw. mit uns zu interagieren. Wenn sie uns über das
        Kontaktformular persönliche Daten von ihnen bekanntgeben, werden wir
        ihre persönlichen Daten verwenden, damit wir beispielsweise ihre Anfrage
        beantworten können.
      </p> */}

      <h2>Was sind personenbezogene Daten?</h2>
      <p>
        Personenbezogene Daten sind alle Angaben über Betroffene, durch die die
        Identität des Betroffenen bestimmt oder bestimmbar ist. Angaben können
        sämtliche Informationen sein, die mit einer Person in Verbindung stehen
        oder gebracht werden können, wie z.B. ihr Name, ihre Adresse, ihre
        E-Mail-Adresse, ihr Geburtsdatum. Wir ersuchen ausschließlich um
        Bekanntgabe jener persönlichen Informationen, welche wir zur
        Auftragserfüllung unbedingt benötigen. Die zur Verfügung gestellten
        Daten werden ausschließlich zur Auftragserfüllung herangezogen. Es
        erfolgt im Übrigen keine Übermittlung der Daten an Dritte, soweit diese
        nicht zur Durchführung einer Anfrage oder Dienstleistung erforderlich
        ist.
      </p>

      <h2>Datensicherheit</h2>
      <p>
        Wir sichern unsere Webseite und die sonstigen Systeme durch technische
        und organisatorische Maßnahmen gegen Verlust, Zerstörung, Zugriff,
        Veränderung oder Verbreitung ihrer Daten und treffen umfangreiche
        Sicherheitsmaßnahmen, um ihre Daten vor unerwünschten Zugriffen zu
        schützen.
      </p>

      <h2>Server-Logfiles</h2>
      <p>
        Wenn sie unsere Webseite besuchen, speichern wir zum Zweck der System-
        und Datensicherheit u.a. folgende Daten (sogenannte Serverlogfiles), die
        ihr Internet-Browser an uns bzw. an unseren Webspace-Provider
        übermittelt, ab:
      </p>

      <ul>
        <li>Browsertyp und -version</li>
        <li>verwendetes Betriebssystem</li>
        <li>Webseite, von der aus sie uns besuchen "Referrer URL"</li>
        <li>Webseite, die sie besuchen</li>
        <li>Datum und Uhrzeit ihres Zugriffs</li>
        <li>Ihre Internet Protokoll (IP)-Adresse</li>
      </ul>

      <p>
        Diese anonymen Daten werden getrennt von ihren eventuell angegebenen
        personenbezogenen Daten gespeichert und lassen so keine Rückschlüsse auf
        eine bestimmte Person zu. Sie werden zu statistischen Zwecken
        ausgewertet, um unseren Internetauftritt und unsere Angebote optimieren
        zu können.
      </p>
    </div>
  </div>
);



// WEBPACK FOOTER //
// /opt/build/repo/src/containers/Datenschutzerklaerung.js